import React from "react";

const InstructorContext = React.createContext()

export default InstructorContext;